import { RiExchangeDollarLine } from "react-icons/ri";
import { PiMoneyWavy } from "react-icons/pi";
import {
    CashTransactionData,
    CreateCashTransaction,
} from "@/pages/cash-transaction";
import {
    CashTransferData,
    CashTransferCreate,
    CashTransferEdit,
} from "@/pages/cash-transfer";

export const financeRoutes = {
    title: "KEUANGAN",
    type: "section",
    items: [
        {
            path: "/cash-transaction",
            title: "Cash Flow",
            icon: <RiExchangeDollarLine />,
            permission: "cash-transaction.view",
            component: <CashTransactionData />,
        },
        {
            path: "/cash-transfer",
            title: "Transfer Kas",
            icon: <PiMoneyWavy />,
            permission: "cash-transfer.view",
            component: <CashTransferData />,
        },
        {
            path: "/cash-transfer/create",
            title: "Buat Transfer",
            component: <CashTransferCreate />,
            permission: "cash-transfer.create",
            type: "hidden",
        },
        {
            path: "/cash-transfer/:id/edit",
            title: "Edit Transfer",
            component: <CashTransferEdit />,
            permission: "cash-transfer.edit",
            type: "hidden",
        },
        {
            path: "/cash-transaction/in/create",
            title: "Catat Pemasukan",
            component: <CreateCashTransaction type="in" />,
            permission: "cash-transaction.create",
            type: "hidden",
        },
        {
            path: "/cash-transaction/out/create",
            title: "Catat Pengeluaran",
            component: <CreateCashTransaction type="out" />,
            permission: "cash-transaction.create",
            type: "hidden",
        },
        {
            path: "/cash-transaction/in/:id/edit",
            title: "Edit Pemasukan",
            component: <CreateCashTransaction type="in" />,
            permission: "cash-transaction.edit",
            type: "hidden",
        },
        {
            path: "/cash-transaction/out/:id/edit",
            title: "Edit Pengeluaran",
            component: <CreateCashTransaction type="out" />,
            permission: "cash-transaction.edit",
            type: "hidden",
        },
    ],
};
